export default "/images/pr-img-6.png?f2db819a991befc3d88cf3ee258b20bc";